export const SCHEME_NAME = "schemeName";
export const SCHEME_NAME_FR = "schemeFrName";
export const SCHEME_DESC_NAME = "schemeDescName";
export const SCHEME_DESC_FR_NAME = "shemeDescFrName";
export const SCHEME_LABEL = "Scheme Name";
export const SCHEME_NAME_LABEL_FR = "Scheme Name (French)";
export const SCHEME_DESC_FR_LABEL = "Scheme Description (French)";
export const SCHEME_DESC_LABEL = "Scheme Description";